/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.179.1-v202608202239-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqAccessKeysApiClass {
 
   constructor() {}

  /**
   * @summary Creates a new Access Key associated with the current session.May be used by User Admins to create Access Keys for other users.
  */
  public createKey(
    body: models.AccessKeyInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/accesskeys`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AccessKeyOutputV1>;
  }

  /**
   * @summary Delete an Access Key
   * @param {string} keyName - Key Information
  */
  public deleteKey(
    {
      keyName
    } : {
      keyName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (keyName === null || keyName === undefined) {
      throw new Error("'keyName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/accesskeys/${encodeURIComponent(String(keyName))}`
      .replace('{keyName}', encodeURIComponent(String(keyName)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Gets Access Keys for current user, a specific user, or all users. Access keys of application service principals are not included in getAll results
   * @param {number} [offset=0] - The pagination offset, the index of the first collection key that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection keys that will be returned in this page of results
   * @param {boolean} [getAll=false] - Get all user keys if true, only the current user&#x27;s keys if false.
   * @param {string} [userId] - If specified, getAll will be ignored and keys for the specified user will be returned. Only administrators may get keys for other users.
  */
  public getKeys(
    {
      offset,
      limit,
      getAll,
      userId
    } : {
      offset?: number,
      limit?: number,
      getAll?: boolean,
      userId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/accesskeys`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['getAll']: getAll,      ['userId']: userId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.AccessKeyOutputListV1>;
  }

}


export const sqAccessKeysApi = new sqAccessKeysApiClass();

export type sqAccessKeysApiEndpoints = {
  'createKey': {
    method: 'post';
    path: '/accesskeys';
    response: models.AccessKeyOutputV1;
  };
  'deleteKey': {
    method: 'delete';
    path: '/accesskeys/${encodeURIComponent(String(keyName))}';
    response: models.StatusMessageBase;
  };
  'getKeys': {
    method: 'get';
    path: '/accesskeys';
    response: models.AccessKeyOutputListV1;
  };
};

type ApiCreateKeyResponse = models.AccessKeyOutputV1;
type ApicreateKeyMutationParams = Parameters<typeof sqAccessKeysApi.createKey> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAccessKeysApi.createKey>;
type ApicreateKeyMutationVariables = models.AccessKeyInputV1;

export function useApiCreateKeyMutation(
  options?: Omit<UseMutationOptions<ApiCreateKeyResponse, AxiosError<SeeqErrorData>,
    ApicreateKeyMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateKeyResponse, AxiosError<SeeqErrorData>,
  ApicreateKeyMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateKeyMutationVariables) =>
      sqAccessKeysApi.createKey(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteKeyResponse = models.StatusMessageBase;
type ApideleteKeyMutationParams = Parameters<typeof sqAccessKeysApi.deleteKey> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAccessKeysApi.deleteKey>;

export function useApiDeleteKeyMutation(
  options?: Omit<UseMutationOptions<ApiDeleteKeyResponse, AxiosError<SeeqErrorData>,
    ApideleteKeyMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteKeyResponse, AxiosError<SeeqErrorData>,
  ApideleteKeyMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteKeyMutationParams) =>
      sqAccessKeysApi.deleteKey(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetKeysResponse = models.AccessKeyOutputListV1;
export function GetKeysQueryKey(
  params: Parameters<typeof sqAccessKeysApi.getKeys>[0],
) {
  return ['sqAccessKeysApi', 'getKeys', params] as const;
}

export function useApiGetKeysQuery(
  params: Parameters<typeof sqAccessKeysApi.getKeys>[0],
  options?: Omit<UseQueryOptions<ApiGetKeysResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetKeysResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetKeysQueryKey(params),
    queryFn: () =>
      sqAccessKeysApi.getKeys(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
